import React from 'react';
const Searching = () => {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="nothing-inner">
              <div className="nothing-icon"><i className="fal fa-spinner fa-spin"></i></div>
              <div className="nothing-content">
                <div className="nothing-text">Searching</div>
                <div className="nothing-sub-text">Searching data for this page</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};
export default Searching;